import * as Types from '../../@types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type DeleteKidsWorldVideoMutationVariables = Types.Exact<{
  kidsWorldVideoId: Types.Scalars['Int']['input'];
}>;


export type DeleteKidsWorldVideoMutation = { __typename?: 'Mutation', deleteKidsWorldVideo: { __typename?: 'ResultResponse', count: number, error?: string | null } };


export const DeleteKidsWorldVideoDocument = gql`
    mutation DeleteKidsWorldVideo($kidsWorldVideoId: Int!) {
  deleteKidsWorldVideo(kidsWorldVideoId: $kidsWorldVideoId) {
    count
    error
  }
}
    `;
export type DeleteKidsWorldVideoMutationFn = Apollo.MutationFunction<DeleteKidsWorldVideoMutation, DeleteKidsWorldVideoMutationVariables>;

/**
 * __useDeleteKidsWorldVideoMutation__
 *
 * To run a mutation, you first call `useDeleteKidsWorldVideoMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteKidsWorldVideoMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteKidsWorldVideoMutation, { data, loading, error }] = useDeleteKidsWorldVideoMutation({
 *   variables: {
 *      kidsWorldVideoId: // value for 'kidsWorldVideoId'
 *   },
 * });
 */
export function useDeleteKidsWorldVideoMutation(baseOptions?: Apollo.MutationHookOptions<DeleteKidsWorldVideoMutation, DeleteKidsWorldVideoMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteKidsWorldVideoMutation, DeleteKidsWorldVideoMutationVariables>(DeleteKidsWorldVideoDocument, options);
      }
export type DeleteKidsWorldVideoMutationHookResult = ReturnType<typeof useDeleteKidsWorldVideoMutation>;
export type DeleteKidsWorldVideoMutationResult = Apollo.MutationResult<DeleteKidsWorldVideoMutation>;
export type DeleteKidsWorldVideoMutationOptions = Apollo.BaseMutationOptions<DeleteKidsWorldVideoMutation, DeleteKidsWorldVideoMutationVariables>;